import { createSlice } from '@reduxjs/toolkit';


const initialState = {
    accessToken: '',
    user: {},
    isAuthenticated: false,
    currentLanguage:"en"
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setAccessToken: (state, action) => {
            state.accessToken = action.payload;
        },
        setcurrentLanguage:(state,action)=>{
         state.currentLanguage=action.payload
        },
        
        setuser: (state, action) => {
            state.user = action.payload;
        },
        
        setIsAuthenticated:(state,action)=>{
         state.isAuthenticated=action.payload
        },
        
        logout: (state, action) => {
            state.user = {}
            state.accessToken = ''
            state.isAuthenticated=false
            
        },
    },
});

export const { setAccessToken, setcurrentLanguage, setuser ,setIsAuthenticated , logout  } = authSlice.actions;

export default authSlice.reducer;